<template>
  <div class="bc" style="position:relative;">
    <!-- 按答卷结算 -->
    <template>
      <!-- 查询 -->
      <el-row :gutter="10" class="search-row" type="flex" justify="space-between">
        <el-col :span="24">
          <search-filter :search-filters="queryFields" :change-handel-function="onChangeSearchField" ref="sf"/>  
        </el-col>
      </el-row>
      <data-table
        :data="data"
        :columns="option.column" 
        :page="page"
        :showPage="true"
        :loading="loading"
        :index="true"
        :indexFixed="true"
        @size-change="sizeChange"
        @pagination-current-change="currentChange"
        :height="'50vh'"
      >
        <!-- 结算状态 -->
        <template #settleStatus="{ row }">
          <div style="text-align：center;">
            <div :class="{'no-settle':row.settleStatus==0,'settlling':row.settleStatus==1,'settled':row.settleStatus==2,'s-status':true}">
              {{ settleStatusMap[row.settleStatus] }}
            </div>
          </div>
        </template>
        <!-- 代理or访问员 -->
        <template #executorName="{ row }">
          <!-- <el-tooltip effect="dark" :content="row.executorId.toString()" placement="top-start">
            <span>{{ row.executorName }}</span>
          </el-tooltip> -->
          <span>{{ row.executorName }}</span>
        </template>
        <!-- 审核员 -->
        <template #auditName="{ row }">
          <el-tooltip effect="dark" :content="row.auditId.toString()" placement="top-start">
            <span>{{ row.auditName }}</span>
          </el-tooltip>
        </template>
        <!-- 审核方式 -->
        <template #qcType="{ row }">
          <span> {{ qcTypeMap[row.qcType] }} </span>
        </template>
        <!-- 调价说明 -->
        <template #adjustDescribe="{ row }">
          <div style="text-align:left" v-if="row.adjustAmount">
            <p>调价人：{{ row.adjusterName }}，调整时间：{{ row.adjustTime }}，</p>
            <p>调整说明：{{ row.adjustDescribe }}</p>
          </div>
        </template>
        <!-- 关联结算单 -->
        <template #statementId="{ row }">
          <span v-if="row.statementId">{{row.statementId}}</span>
          <span v-else style=""></span>
        </template>
        <!-- 空状态 -->
        <template slot="empty">
          <empty-prompt :isAllOrNet="true" />
        </template>
        <!-- 菜单 -->
        <template #opt="{ row }">
          <el-button @click="toDetail(row)" type="text">查看</el-button>
        </template>
      </data-table>
    </template>
    <el-drawer
      :title="'答卷详情'"
      size="75%"
      :visible.sync="drawer"
      :modal="false"
      :destroy-on-close="true">
      <div class="px-6 py-4">
        <nobtn-detail :answerId="currentAnswerId" :key="currentAnswerId"></nobtn-detail>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import EmptyPrompt from '@/components/base/EmptyPrompt'
import SearchFilter from '@/components/search-filter/SearchFilter'
import { deepClone } from '@/assets/js/utils'
import { getAnswerInterviewers, getAnswerSheetList  } from "@/api/wenjuan/settlement"
import nobtnDetail from '@/components/survey-detail/DetailShow'
import { answerSheetListOptions as offlineOpt} from '@/views/survey/settlement/offline/options'
import { answerSheetListOptions as proxyOpt} from '@/views/survey/settlement/proxy/options'
import { answerSheetListOptions as visitorOpt} from '@/views/survey/settlement/visitor/options'
import { answerSheetListSearchFields as offlineSF} from '@/views/survey/settlement/offline/search'
import { answerSheetListSearchFields as proxySF} from '@/views/survey/settlement/proxy/search'
import { answerSheetListSearchFields as visitorSF} from '@/views/survey/settlement/visitor/search'
import DataTable from '@/components/base/DataTable'

export default {
  components: {
    EmptyPrompt,SearchFilter,nobtnDetail,DataTable
  },
  props: {
    settleType: { // 0=委托方页面,1=代理页面,2=面访页面
      type: Number,
      default: 0
    },
    surveyId: {
      type: String,
      default: ''
    },
    surveyTitle: {
      type: String,
      default: ''
    },
    statementId: {
      type: String,
      default: ''
    }
  },
  data() {
    let opt= {
    }
    let offlineOptions = Object.assign({}, offlineOpt, opt)
    let proxyOptions = Object.assign({}, proxyOpt, opt)
    let visitorOptions = Object.assign({}, visitorOpt, opt)

    offlineOptions.column = [...offlineOptions.column]
    proxyOptions.column = [...proxyOptions.column]
    visitorOptions.column = [...visitorOptions.column]
    
    offlineOptions.column = offlineOptions.column.filter(item=>item.prop != 'settleStatus')
    proxyOptions.column = proxyOptions.column.filter(item=>item.prop != 'settleStatus')
    visitorOptions.column = visitorOptions.column.filter(item=>item.prop != 'settleStatus')
    offlineOptions.column.forEach((filterItem) => {
      if(filterItem.prop=='realAmount') {
        filterItem.renderHeader = null
      }
      if(filterItem.prop=='opt') {
        filterItem.width = 100
      } 
    })
    proxyOptions.column.forEach((filterItem) => {
      if(filterItem.prop=='realAmount') {
        filterItem.renderHeader = null
      }
      if(filterItem.prop=='opt') {
        filterItem.width = 100
      } 
    })
    visitorOptions.column.forEach((filterItem) => {
      if(filterItem.prop=='realAmount') {
        filterItem.renderHeader = null
      }
      if(filterItem.prop=='opt') {
        filterItem.width = 100
      } 
    })
    let offlineSearchFields = offlineSF.filter(item=>item.prop != 'settleStatus')
    let proxySearchFields = proxySF.filter(item=>item.prop != 'settleStatus')
    let visitorSearchFields = visitorSF.filter(item=>item.prop != 'settleStatus')
    offlineSearchFields.forEach((filterItem) => {
      if(filterItem.prop=='auditTime') {
        filterItem.lg = 6
        filterItem.sm = 24
        filterItem.md = 8
      } else {
        filterItem.lg = 5
        filterItem.sm = 24
        filterItem.md = 8
      }
    })
    return {
      loading: false,
      settleStatusMap:{
        0:'未结算',
        1:'正在结算',
        2:'已结算'
      },
      qcTypeMap:{
        0:'其他',
        1:'自动过审',
        2:'人工审核',
        3:'批量审核',
        4:'质控题'
      },
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
        pageSizes: [10, 30, 50, 100]
      },
      offlineOptions,
      proxyOptions,
      visitorOptions,
      offlineSearchFields,
      proxySearchFields,
      visitorSearchFields,
      option: offlineOptions,
      queryFields: offlineSearchFields,
      data: [],
      forms: {},
      currentAnswerId: '',
      drawer: false
    };
  },
  methods: {
    toDetail(row) {
      this.currentAnswerId = row.answerId
      this.drawer = true
    },
    getList(params) {
      this.loading = true
      getAnswerSheetList(params).then((res) => {
        this.totalYuanAmount = Number(res.data.data.totalYuanAmount).toFixed(2)
        if(params.settleStatus==0) {
          this.total = res.data.data.total
        } else {
          this.total = 0
        }
        this.page.total = res.data.data.total
        this.page.currentPage = res.data.data.current
        this.page.pageSize = res.data.data.size
        this.data = res.data.data.records
        this.data.forEach(item =>{
          item.singleAmount = Number(item.singleAmount)?(Number(item.singleAmount)/100).toFixed(2):Number(item.singleAmount).toFixed(2)  
          item.realAmount = Number(item.realAmount)?(Number(item.realAmount)/100).toFixed(2):Number(item.realAmount).toFixed(2) 
          if (item.adjustAmount && item.adjustAmount != '0') {
            let sign = item.adjustAmount.substring(0, 1)
            let adjustAmountReal = item.adjustAmount.substring(1)
            item.adjustAmount = sign + (Number(adjustAmountReal)/100).toFixed(2)
          } else {
            item.adjustAmount = ''
          }
        })
        // 如果当前查询页数 没有数据 往前一页查询一次
        if (this.data.length === 0 && this.page.currentPage != 1) {
          this.page.currentPage--
          if (this.page.currentPage > 0) {
            params.current = this.page.currentPage
            getList(params)
          }
        }
        this.loading = false
      }).catch((err) => {
        console.log(err)
        // return err
      })
    },
    // 整理请求数据
    handleData() {
      const fs = deepClone(this.forms)
      fs.current = this.page.currentPage
      fs.size = this.page.pageSize
      fs.surveyId = this.surveyId
      fs.settleType = this.settleType
      fs.statementId = this.statementId
      return fs
    },
    commonChange() {
      this.getList(this.handleData())
    },
    onChangeSearchField(params) {
      if(params.executorIds) {
        params.executorIds = params.executorIds.join(',')
      }
      if(params.auditTimeMin) {
        params.auditTimeBegin = params.auditTimeMin
        delete params.auditTimeMin
      }
      if(params.auditTimeMax) {
        params.auditTimeEnd = params.auditTimeMax
        delete params.auditTimeMax
      }
      this.forms = params
      this.page.currentPage = 1
      this.commonChange()
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      //   重新渲染
      this.commonChange()
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      //   重新渲染
      this.commonChange()
    },
    getAnswerInterviewers() {
      let params = {
        surveyId: this.surveyId,
        settleType: this.settleType,
        statementId: this.statementId
      }
      getAnswerInterviewers(params).then(res => {
        let data = res.data.data
        this.queryFields[0].options = data.map(item => {
          let opItem = {}
          opItem.label = item.name || item.phone
          opItem.value = item.id
          return opItem
        })
      }).catch( err =>{
      })
    },
    init() {
      if(this.settleType == 0 ) {
        this.option = this.proxyOptions
        this.queryFields = this.proxySearchFields
      } else if (this.settleType == 1) {
        this.option = this.visitorOptionsd
        this.queryFields = this.visitorSearchFields
      } else if (this.settleType == 2) {
        this.option = this.offlineOptions 
        this.queryFields = this.offlineSearchFields
      }
      if(this.settleType == 2 || this.settleType == 3) {
        this.getAnswerInterviewers()
      }
      this.commonChange()
    }
  },
  created() {
    this.init()
  }
};
</script>

<style scoped lang="scss">
@import '~@/assets/scss/line-style.scss';
.tips {
  position: absolute;
  top: 9px;
  right: 1px;
  cursor: pointer;
}
.tips-btn {
  position: relative;
}
::v-deep .el-table th div {
  line-height: 23px;
  white-space: normal;
  padding-left: 0px;
  display: block;
}
.tips-p {
  position: absolute;
  top: -50px;
  right: -9px;
  cursor: pointer;
  margin: 0;
}
.tips-p2 {
  position: absolute;
  top: -50px;
  right: -17px;
  cursor: pointer;
  margin: 0;
}
.bach-red {
  color:red;
  font-size: 14px;
  font-weight: 600;
}
.bach-blue {
  color:blue;
  font-size: 14px;
  font-weight: 600;
}
.bach-line {
  margin-bottom: 25px;
  padding-left: 10px;
}
.sum-line {
  // position: absolute;
  // bottom: 2px;
  // left: 10px;
  .el-button {
    margin-left: 20px;
  }
  .total-sum {
    position: relative;
    left: 80px;
  }
}
.red-line {
  position: absolute;
  bottom: -22px;
  left: 70px;
}

::v-deep .el-drawer__header {
  margin-bottom: 0px;
  padding: 10px 0 10px 20px;
  text-align: left;
  border-bottom: 1px solid rgba(0,0,0,0.09);
  opacity: 0.85;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #111111;
  line-height: 16px;
}
.no-settle {
  color: #cccccc;
  background: #ffffff;
  border: 1px solid #cccccc;
}
.settlling {
  color: #ff9932;
  background: #fff6ec;
  border: 1px solid #ff9932;
}
.settled {
  color: #b2d799;
  background: #f0f9ea;
  border: 1px solid #b2d799;
}
.s-status{
  border-radius: 2px;
  width: 63px;
  display: inline-block;
  height: 26px;
}
.top-line {
  margin-bottom: 13px;
  .text1 {
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
  }
  .text2 {
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
  }
  .text3 {
    font-size: 16px;
    color: #227FFE;
    line-height: 22px;
    cursor: pointer;
  }
}  
.sel-page {
  margin-left: 12px;
  margin-bottom: 20px;
  width: 150px;
  ::v-deep .el-input__inner {
    background-color: #227FFE;
    color: #fff;
    border-color: #227FFE;
  }
  ::v-deep .el-input .el-select__caret {
    color: #fff;
  }
}
::v-deep .basic-container {
  border-radius: 0px;
}
.search-row {
  .el-col-24 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}
.el-button--text {
  border: unset;
}
// .el-button--text:focus, .el-button--text:hover {
//   color: #66b1ff;
//   border-color: #fff;
//   background-color: #fff;
// }
button:focus {
  outline: unset;
}
</style>
